import api from './api';

export type DeckType = 'sales' | 'qbr' | 'case_study' | 'onboarding';

export interface GenerateDeckInput {
  source: string;
  title?: string;
  deckType?: DeckType;
  language?: string;
}

class SlideDeckService {
  // Returns the .pptx as a Blob plus the server-suggested filename.
  async generate(input: GenerateDeckInput): Promise<{ blob: Blob; filename: string }> {
    const response = await api.post('/slide-deck/generate', input, { responseType: 'blob' });
    const disposition = (response.headers['content-disposition'] as string) || '';
    const match = disposition.match(/filename="?([^"]+)"?/);
    const filename = match ? match[1] : 'deck.pptx';
    return { blob: response.data as Blob, filename };
  }
}

const slideDeckService = new SlideDeckService();
export default slideDeckService;
